import axios from "axios";

const apiManagement = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_MANAGEMENT_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8081",
});

export default apiManagement;
